"use strict";

// LinkMessageHelper
module.exports = {
	linkMessageMapper(dataDynamicHref, $selectedElement) {
		switch (dataDynamicHref) {
			case "addNewPayment": return "'Add New Payment' link clicked.";
			case "removeSavedPayment": return "Remove From Saved Payments called successfully.";

			case "addRegistrant": return "Add Registrant link called successfully.";
			case "removeRegistrant": return "Remove Registrant link called successfully.";

			case "myEventsDetailPage": return "My Events Detail Page link called successfully.";

			case "cancelMyPledge": return "Canceling the Pledge called successfully.";
			case "cancelMyPledgeEdit": return "Cancel Pledge Edit called successfully.";
			case "editMyPledge": return "Edit Pledge called successfully.";
			case "navigateToSecureProjectFromMyPledge": return "Navigate to Secure Project Link called successfully.";

			case "cancelMySponsorship": return "Canceling the Sponsorship called successfully.";
			case "cancelMySponsorshipEdit": return "Cancel Sponsorship Edit called successfully.";
			case "editMySponsorship": return "Edit Sponsorship called successfully.";
			case "viewChildCommunications": return "View Child Communications called successfully.";

			case "cancelRecurring": return "Cancelling the Recurring called successfully.";
			case "cancelRecurringDonationEdit": return "Cancel Recurring Donation Edit called successfully.";
			case "cancelRecurringHeaderEdit": return "Cancel Recurring Header Edit called successfully.";
			case "cancelRecurringPaymentEdit": return "Cancel Recurring Payment Edit called successfully.";
			case "deleteRecurringDonation": return "Delete Recurring Donation called successfully.";
			case "editRecurringDonation": return "Edit Recurring Donation called successfully.";
			case "editRecurringHeader": return "Edit Recurring Header called successfully.";
			case "editRecurringPayment": return "Edit Recurring Payment called successfully.";

			case "createCommunication": return "Create Communication called successfully.";

			case "documentsLoadPartial": return "Navigate to Document Type called successfully.";
			case "documentsDownload": return "Download Document called successfully.";

			case "reportsDownload": return "Download Report called successfully.";
			case "reportsLoadPartial": return "Load Report Parameters called successfully.";

			case "magazineEmailSubscriptionEdit": return "Magazine Email Subscription Edit called successfully";
			case "magazineEmailSubscriptionCancelEdit": return "Cancel Magazine Email Subscription Edit called successfully";

			case "magazineMailSubscriptionEdit": return "Magazine Mail Subscription Edit called successfully";
			case "magazineMailSubscriptionCancelEdit": return "Cancel Magazine Mail Subscription Edit called successfully";

			case "membershipSubscriptionEdit": return "Membership Subscription Edit called successfully";
			case "membershipSubscriptionCancelEdit": return "Cancel Membership Subscription Edit called successfully";

			case "productSubscriptionEdit": return "Product Subscription Edit called successfully";
			case "productSubscriptionCancelEdit": return "Cancel Product Subscription Edit called successfully";

			case "addNewOtherAddress": return "Show Add Other Address called successfully.";
			case "cancelAddOtherAddress": return "Cancel Add Other Address Form called successfully.";
			case "cancelEditOtherAddress": return "Cancel Edit Other Address called successfully.";
			case "deleteOtherAddress": return "Delete Other Address called successfully.";
			case "editOtherAddress": return "Edit Other Address called successfully.";

			case "productKitItemLink": return "Product Kits Item Link called successfully.";

			case "category": return "Category Link called successfully.";
			case "event":
			case "register":
				return "Event Link called successfully.";
			case "pledge": return "Pledge Link called successfully.";
			case "product":
			case "purchase":
				return "Product Link called successfully.";
			case "project":
			case "donate":
				return "Project Link called successfully.";
			case "subscription":
			case "subscribe":
				return "Subscription Link called successfully.";
			case "downloadUrl": return "Download Link called successfully.";

			case "toSaveForLater": return "Move To Save For Later called successfully.";
			case "toShoppingCart": return "Move To Shopping Cart called successfully.";

			case "removePremium": return "Remove Donation Premium called successfully.";
			case "removeFromCart": return "Remove From Cart called successfully.";
			case "removeCouponLink": return "Remove Coupon called successfully.";
			case "removeGroupCodeLink": return "Remove Group Code called successfully.";

			case "sponsor-a-child": return "Link to Child Sponsorship called successfully.";

			case "tangible": return "Link to Tangible called successfully.";
			default:
				if ($selectedElement) {
					//In these cases the data-dynamic-href is "true"; it was one of, if not the first case.
					if ($selectedElement.parents("[data-component='category.category'],[data-component='carousel.category']").length) {
						return "Category Link called successfully.";
					} else if ($selectedElement.parents("[data-component='category.project'],[data-component='carousel.project']").length) {
						return "Project Link called successfully.";
					} else if ($selectedElement.parents("[data-component='category.product'],[data-component='carousel.product']").length) {
						return "Product Link called successfully.";
					} else if ($selectedElement.parents("[data-component='category.pledge'],[data-component='carousel.pledge']").length) {
						return "Pledge Link called successfully.";
					} else if ($selectedElement.parents("[data-component='category.event'],[data-component='carousel.event']").length) {
						return "Event Link called successfully.";
					} else if ($selectedElement.parents("[data-component='category.subscription'],[data-component='carousel.subscription']").length) {
						return "Subscription Link called successfully.";
					}
				}

				return null;
		}
	}
};
